module.exports = __webpack_public_path__ + "img/rhea.267bbbde.jpg";